export const queryString = (query) => new URLSearchParams(query).toString();
export const callWrapper = (apiCall) => (...args) =>
    new Promise((resolve, reject) => {
        apiCall
            .apply(this, args)
            .then((response) => {
                const successCodes = [200, 201, 204];
                if (response && successCodes.includes(response.status)) {
                    resolve(response.data);
                } else {
                    reject(new Error(response.statusText));
                }
            })
            .catch((error) => {
                console.error(error);
                reject(error.response);
            });
    });
